import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'recording_signUpPageShown',
  'recording_signUpWithGoogleClick',
  'recording_signUpWithSSOClick',
  'recording_emailSignUpEntered',
  'recording_passwordSignUpEntered',
  'recording_emailSignUpProceedClick',
  'recording_confirmYourEmailScreenShown',
  'recording_confirmEmailButtonClick',
  'recording_backToSignUpFromCodeClick',
  'recording_resendConfirmationCodeClick',
  'recording_signInClick',
  'recording_authErrorShown',
] as const;

export const recordingAuthEvents = getMappedEvents([...EVENTS]);
